import { post } from '@/utils/network/axios-helper';
import { HomeworkTransport, teacherPracticePost } from '@/utils/teacherPracticeTransport';

export interface MockPracticeLaunchResponse {
  mode: string;
  target: string;
  record_id?: number | string;
  session_token?: string;
  expires_at?: string;
  scope?: { native_record_id?: number | string; allow_write?: boolean; read_only?: boolean; };
  exercise?: { kind?: string; };
}

export async function exchangePracticeLaunchTicket(ticket: string, transport: HomeworkTransport = 'student') {
  const response = transport === 'teacher'
    ? await teacherPracticePost<MockPracticeLaunchResponse>('exchange', { ticket })
    : await post<MockPracticeLaunchResponse>('/api/practice/launch/exchange', { ticket });
  return response.data;
}
